import styled from 'styled-components';

export const PreformattedText = styled.pre`
  overflow: unset;
`;
